jQuery.fn.extend({
    createRepeater: function (options = {}) {

        this.addButtonCallback = options.addButtonCallback;
        var hiddenItems = 0;

        var hasOption = function (optionKey) {
            return options.hasOwnProperty(optionKey);
        };

        var option = function (optionKey) {
            return options[optionKey];
        };

        var generateId = function (string) {
            return string
                .replace(/\[/g, '_')
                .replace(/\]/g, '')
                .toLowerCase();
        };

        var addItem = function (items, key, fresh = false) {
            var itemContent = items;
            var group = itemContent.data("group");
            var item = itemContent;
            var input = item.find('input, select');
            input.each(function (index, el) {
              if(!$(el).hasClass('no-repeater')) {
                var attrName = $(el).attr('data-old-name') || $(el).data('name');
                var attrValue = $(el).data('value');
                var skipName = $(el).data('skip-name');
                var multiple = $(el).attr('multiple');
                let attr = "name"
                $(el).attr("data-old-name", attrName)


                if($(el).closest(".simple-repeater").length){
                  attr = "data-name"
                }
                if (skipName != true) {
                    if(attrName && attrName[0] != "["){
                      attrName = "[" + attrName + "]"
                    }
                    if (multiple)
                        $(el).attr(attr, group + "[" + key + "]" + attrName + "[]");
                    else
                        $(el).attr(attr, group + "[" + key + "]" + attrName);
                } else {
                    if (attrName != 'undefined') {
                        $(el).attr(attr, attrName);
                    }
                }
                if (attrValue != 'undefined') {
                  $(el).attr("value", attrValue);
                }

                if (fresh == true) {
                  $(el).attr('value', '');
                  if($(el).hasClass("ignore-repeater")){
                    $(el).parent().parent().parent().remove()
                  }
                }

                if($(el).data('clone-value')){
                  $(el).attr("value", attrValue);
                }

                $(el).attr('id', generateId($(el).attr(attr)));
                $(el).parent().find('label').attr('for', generateId($(el).attr(attr)));
              }
            })

            var itemClone = items;

            /* Handling remove btn */
            var removeButton = itemClone.find('.remove-btn');
            var itemClasses = "items"
            if (itemClone.hasClass("hide") && !fresh ) {
              itemClasses = itemClasses + " hide"
              hiddenItems = hiddenItems + 1
            }
            var newKey = key - hiddenItems
            if (newKey == 0 && !removeButton.hasClass("do-not-hide")) {
                removeButton.attr('disabled', true).addClass('hide');
            } else {
                removeButton.attr('disabled', false).removeClass('hide');
            }
            removeButton.attr('onclick', 'removeElement(this)');
            var newItem = $("<div class='"+ itemClasses +"'>" + itemClone.html() + "<div/>");
            var number = $('.items:visible').length;
            newItem.attr('data-index', key)
            newItem.find('.nr').html(newKey+1);
            dropzoneItem =newItem.find(".stop_dropzone")
            dropzoneItem.attr("data-stop-position", key);
            if(fresh){
              dropzoneItem.attr("data-id", "");
              newItem.find(".simple-repeater .repeater-item").each(function(index, el){
                if(index > 0){
                  $(el).remove();
                }
              })
            }

            newItem.appendTo(repeater);

            newItem.find(".selectize-in-repeater[multiple]").selectize({
                create: false,
                multiple: true
            });

            $(".stop_dropzone").each(function(index){
              let dropzoneControl = $(this)[0].dropzone;
              if (dropzoneControl) {
                  dropzoneControl.destroy();
              }
              var locc_id = $("#location_id").val()
              var stop_id = $(this).data("id")
              var stop_position = $(this).data("stop-position")
              var url = "/locations/upload_stop_attachment"
              if(stop_id != ""){
                url = "/locations/"+locc_id+"/upload_stop_attachment?stop_id="+stop_id+"&stop_position="+stop_position
              }else{
                url = "/locations/upload_stop_attachment?stop_position="+stop_position
              }
              $(this).dropzone({
                url: url,
                paramName: "file",
                acceptedFiles: "image/*,application/pdf, .heif, .heic",
                success: function (file, response) {
                  var new_item = $(response.field).hide();
                  $($($(this)[0].element).parent().siblings().find(".stop_attachments")[0]).append(new_item)
                  new_item.show('normal');
                }
            });
        })
        };

        /* find elements */
        var repeater = this;
        var items = repeater.find(".items");
        var key = 0;
        // var addButton = repeater.find('.repeater-add-btn');

        var addButton;
        if (repeater.attr("id"))
            addButton = $(".repeater-add-btn[data-repeater-id=" + repeater.attr("id") + "]");
        if (!addButton || !addButton.length)
            addButton = $(".repeater-add-btn:not([data-repeater-id])");

        if(hasOption('addButton') && typeof option('addButton')  !== "undefined") {
          addButton = option('addButton');
        }

        items.each(function (index, item) {
            items.remove();
            if ($(item).hasClass("sample-item"))
                return;
            if (hasOption('showFirstItemToDefault') && option('showFirstItemToDefault') == true) {
                var item = addItem($(item), key, false);

                // if ($.isFunction(addButtonCallback)) {
                //     addButtonCallback.call(this, item);
                // }

                key++;
            } else {
                if (items.length > 1) {
                    addItem($(item), key);
                    key++;
                }
            }
        });



        /* handle click and add items */
        addButton.on("click", function () {
            // $('.items:not(:last-child)').css('padding-bottom', 'rem-calc(30 50)');
            var item = addItem($(items[0]), key, true);
            key++;
            initializeSimpleRepeater();

            if ($.isFunction(repeater.addButtonCallback)) {
                repeater.addButtonCallback.call(repeater, item);
            }
        });
    }
});
